import { getToken } from "firebase/messaging";
import { Dispatch } from "redux";
import { messaging } from "../firebase";
import { log } from "node:console";

const VAPID_KEY = process.env.REACT_APP_VAP_ID;

export const requestForToken = async (currentToken: string | undefined) => {
  try {
    if (!currentToken) {
      currentToken = await getToken(messaging, {
        vapidKey: VAPID_KEY,
      });
    }
    if (currentToken) {
      localStorage.setItem("fcm_device_token", currentToken);
    } else {
    }
  } catch (err) {}
};
